export class HighFrequencyIntervalConfig {
    'intervalMinutes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "intervalMinutes",
            "baseName": "intervalMinutes",
            "type": "HighFrequencyIntervalConfigIntervalMinutesEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HighFrequencyIntervalConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var HighFrequencyIntervalConfigIntervalMinutesEnum;
(function (HighFrequencyIntervalConfigIntervalMinutesEnum) {
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_15"] = 15] = "NUMBER_15";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_30"] = 30] = "NUMBER_30";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_60"] = 60] = "NUMBER_60";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_120"] = 120] = "NUMBER_120";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_180"] = 180] = "NUMBER_180";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_240"] = 240] = "NUMBER_240";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_360"] = 360] = "NUMBER_360";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_480"] = 480] = "NUMBER_480";
    HighFrequencyIntervalConfigIntervalMinutesEnum[HighFrequencyIntervalConfigIntervalMinutesEnum["NUMBER_720"] = 720] = "NUMBER_720";
})(HighFrequencyIntervalConfigIntervalMinutesEnum || (HighFrequencyIntervalConfigIntervalMinutesEnum = {}));
